import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 16px;
`;
